module.exports = __webpack_public_path__ + "img/icon-personal-finances.e54bffdd.svg";